export const flag_improve_availability_checker = {
    key: 'improve-availability-checker',
    simple_button: 'simple_button',
    creative_style: 'creative_style',
};
export const flag_uk_pdp_open_pricing = {
    key: 'uk-pdp-open-pricing',
    non_open_pricing: 'non_open_pricing',
};
export const flag_category_page_initial_results_count = {
    key: 'category-page-initial-results-count',
    explicit_count: 'explicit_count',
    default_count: 'default_count',
};
export const flag_bullets_on_funeral_products = {
    key: 'bullets-on-funeral-products',
    original: 'original',
    variation: 'variation',
};
export const enforce_component_load_sequence = { key: 'enforce-component-load-sequence' };
export const enforce_convert_sync_mode = { key: 'enforce-convert-sync-mode' };
export const click_and_collect = { key: 'click-and-collect' };
export const occasions_for_personalised_message = { key: 'occasions-for-personalised-message' };
export const show_personalised_message_box = {
    key: 'show-personalised-message-box',
    original: 'original',
    variation: 'variation',
};
export const pcc_edit_phase2_feature = { key: 'pcc-edit-phase-2', original: 'original', variation: 'variation' };
export const enable_tabbed_delivery_options = {
    key: 'enable-tabbed-delivery-options',
    original: 'original',
    variation: 'variation',
};
export const pdp_video_alt_1 = { key: 'pdp-video-alt-1' };
export const q3_birthday_campaign = {
    key: 'q3-birthday-campaign',
    loser: 'looser',
    winner: 'winner',
};
export const enable_zendesk = {
    key: 'enable-zendesk',
};
export const enable_address_lookup_eav_version = {
    key: 'enable-address-lookup-eav-version',
};
export const pdp_alternate_flow_test_one = {
    key: 'pdp-alternate-flow-test-one',
    original: 'original',
    variation: 'variation',
};
export const pdp_alternate_flow_test_two = {
    key: 'pdp-alternate-flow-test-two',
    control: 'control',
    variation1: 'variation1',
    variation2: 'variation2',
};
export const live_pdp_alternate_flow_one = {
    key: 'live-pdp-alternate-flow-one',
};
export const enable_updated_pdp_calendar_logic = {
    key: 'enable-updated-pdp-calendar-logic',
};
export const enable_trustpilot_reviews = { key: 'enable-trustpilot-reviews' };
export const quick_category_facets = { key: 'quick_category_facets' };
export const category_pcc = {
    key: 'category_pcc',
};
export const product_card_redesign = {
    key: 'product_card_redesign',
};
export const flag_algolia_rotation_indicator_filter = {
    key: 'flag-algolia-rotation-indicator-filter',
};
export const enable_google_gateway_tag_implementation = {
    key: 'enable-google-gateway-tag-implementation',
};
